import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import axios from 'axios';
Vue.prototype.$axios = axios;
import QS from 'qs'
Vue.prototype.qs = QS;
import Viser from 'viser-vue'
Vue.use(Viser)
Vue.use(Antd)
Vue.config.productionTip = false
import router from './router/index.js'	
import request from './request.js'
Vue.prototype.$request = request
Vue.prototype.$host = 'https://chejianadmin.dayujh.cn'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
